import { DropdownItem } from 'reactstrap';
import { useHandleTransferJob } from '../dispatchPlus/Dispatch/Jobs/Job/TransferJob';

export const TransferJob = ({
    job, day, dispatchLocations, onSuccess,
}) => {
    const handleClick = useHandleTransferJob({
        job, day, dispatchLocations, onSuccess,
    });

    return (
        <DropdownItem
            className="text-warning"
            onClick={handleClick}
        >
            Transfer Job
        </DropdownItem>
    );
};